export enum ResolutionType {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

type ResolutionSettings = {
  [key in ResolutionType]: { min: number; max?: number }
}

const DEFAULT_SETTINGS: ResolutionSettings = {
  [ResolutionType.XS]: { min: 0, max: 767 },
  [ResolutionType.SM]: { min: 768, max: 1023 },
  [ResolutionType.MD]: { min: 1024, max: 1439 },
  [ResolutionType.LG]: { min: 1440 },
}

function getWidthScreen() {
  return typeof window !== 'undefined' ? document.body.clientWidth : 1024
}

export class ResolutionEventDispatcher {
  type: ResolutionType
  settings: ResolutionSettings = DEFAULT_SETTINGS

  evMap: { [key: string]: ((...args: any) => void)[] } = {}

  constructor(settings?: ResolutionSettings) {
    if (settings) {
      this.settings = settings
    }

    this.type = this._getType(getWidthScreen())

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        const prevType = this.type
        const nextType = this._getType(getWidthScreen())
        if (prevType !== nextType) {
          this._publish('change', { next: nextType, prev: prevType })
          this._publish(`hide-${prevType}`)
          this.type = nextType
          this._publish(`show-${nextType}`)
        }
      })
    }
  }

  recalculate() {
    this.type = this._getType(getWidthScreen())
  }

  subscribe(event: string, cb: (...args: any) => void) {
    if (this.evMap[event]) {
      this.evMap[event].push(cb)
    } else {
      this.evMap[event] = [cb]
    }

    return () => this.unsubscribe(event, cb)
  }

  unsubscribe(event: string, cb: (...args: any) => void) {
    if (this.evMap[event]) {
      this.evMap[event] = this.evMap[event].filter((lcb) => lcb !== cb)
    }
  }

  is(type: ResolutionType) {
    return this.type === type
  }

  private _getType(width: number): ResolutionType {
    return (
      (Object.keys(this.settings) as ResolutionType[]).find((resolve) => {
        if (width >= this.settings[resolve].min) {
          if (typeof this.settings[resolve].max !== 'undefined') {
            if (width <= this.settings[resolve].max) {
              return true
            }
          } else {
            return true
          }
        }
        return false
      }) ?? ResolutionType.MD
    )
  }

  private _publish(event: string, ...args: any) {
    if (this.evMap[event]) {
      this.evMap[event].forEach((cb) => cb(...args))
    }
  }
}

export const resolutionEventDispatcher = new ResolutionEventDispatcher()
